import { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import {
  useAddLeaveConfiguration,
  useLeaveConfigurationData,
  useUpdateLeaveConfiguration,
} from "./hooks/useLeave";
import LeaveConfigurationModal from "./components/LeaveConfigurationModal";
import { FaEdit } from "react-icons/fa";
import { showToast } from "../../utils/toastUtils";
import { BASE_URL } from "../../Api/config";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { COLORS } from "../../constants/colors";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";

type Props = {};

const LeaveConfiguration = (props: Props) => {
  const { startPolling, stopPolling } = useExcelPolling();
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
  const [leaveConfigurationModal, setLeaveConfigurationModal] = useState(false);
  const [editLeaveConfigurationModal, setEditLeaveConfigurationModal] =
    useState("");
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [filtersState, setFiltersState] = useState<any>({
    id: null,
    search: null,
    page: 1,
    limit: 10,
  });
  const [leaveConfigId, setLeaveConfigId] = useState(null);

  const [buttonDisable, setButtonDisable] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const handleClose = () => {
    setLeaveConfigurationModal(false);
    setButtonDisable(false);
  };

  const { data: leaveConfigurationData, isLoading: leaveConfigurationLoading } =
    useLeaveConfigurationData({
      enable: true,
      params: {
        id: null,
        search: filtersState.search,
        page: filtersState.page,
        limit: filtersState.limit,
      },
    });

  console.log(
    "🚀 ~ LeaveConfiguration.tsx:49 ~ LeaveConfiguration ~ leaveConfigurationData:",
    leaveConfigurationData?.data?.data
  );

  const { mutate } = useAddLeaveConfiguration();
  const { mutate: updateLeaveConfiguration } = useUpdateLeaveConfiguration();

  const handleLeaveRequestView = () => {
    setLeaveConfigurationModal(!leaveConfigurationModal);
    setEditLeaveConfigurationModal("Submit");
    setSelectedRowData(null);
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const toggleModal = () => {
    setLeaveConfigurationModal(!leaveConfigurationModal);
    setEditLeaveConfigurationModal("");
    setSelectedRowData(null);
    setButtonDisable(false);
  };

  const handleSubmit = (formData: any) => {
    const attachmentValue = Number(formData?.attachment);
    const adminApprovalValue = Number(formData?.adminApproval);

    // Attachment validation
    if (formData.showAttachment) {
      if (
        isNaN(attachmentValue) ||
        attachmentValue < 0 ||
        attachmentValue > 90
      ) {
        showToast.warning(
          "Please enter a valid number of days (0–90) in the Attachment field."
        );
        setButtonDisable(false);
        return;
      }
    }

    // Admin Approval validation
    if (formData.showAdminApproval) {
      if (
        isNaN(adminApprovalValue) ||
        adminApprovalValue < 0 ||
        adminApprovalValue > 90
      ) {
        showToast.warning(
          "Please enter a valid number of days (0–90) in the Admin Approval field."
        );
        setButtonDisable(false);
        return;
      }
    }

    if (!formData?.name) {
      showToast.warning("Please Fill Name Field!");
      setButtonDisable(false);
      return;
    }
    if (!formData?.policyYear.toString()) {
      showToast.warning("Please Fill Policy Year Field!");
      setButtonDisable(false);
      return;
    }
    if (!formData?.leaveType) {
      showToast.warning("Please Fill Leave Type Field!");
      setButtonDisable(false);
      return;
    }
    if (!formData?.leavePoints) {
      showToast.warning("Please Fill Leave Points Field!");
      setButtonDisable(false);
      return;
    }
    if (!formData?.applyDate) {
      showToast.warning("Please Fill Applicable Date Field!");
      setButtonDisable(false);
      return;
    }
    if (!formData?.selectedOrgUnits?.length) {
      showToast.warning("Please Fill Org Unit Field!");
      setButtonDisable(false);
      return;
    }
    if (!formData?.grade) {
      showToast.warning("Please Fill Grade Field!");
      setButtonDisable(false);
      return;
    }

    // setButtonDisable(true);
    const body = {
      Name: formData?.name,
      GradeId: Number(formData?.grade),
      PolicyYear: formData?.policyYear.toString(),
      LeaveType: formData?.leaveType,
      LeavePoints: formData?.leavePoints,
      ApplyDate: formData?.applyDate,
      Orgunitids: formData?.selectedOrgUnits?.map(Number),
      IsAttachmentReq: formData?.attachment,
      AdminApproval: formData?.adminApproval,
      IsActive: formData?.isActive,
    };

    console.log("🚀 ~ LeaveConfiguration.tsx:94 ~ handleSubmit ~ body:", body);

    setButtonDisable(true);

    const closeModal = () => {
      handleClose();
      setEditLeaveConfigurationModal("");
      setSelectedRowData(null);
      setButtonDisable(false); // ✅ Always re-enable in settled
    };

    if (editLeaveConfigurationModal === "Submit") {
      mutate(body, {
        onSuccess: closeModal,
        onSettled: closeModal,
      });
    } else {
      updateLeaveConfiguration(
        { id: Number(leaveConfigId), body },
        {
          onSuccess: closeModal,
          onSettled: closeModal,
        }
      );
    }
  };

  const handleUpdateLeaveConfiguration = (row: any, status: string) => {
    setLeaveConfigurationModal(!leaveConfigurationModal);
    setEditLeaveConfigurationModal(status);
    setSelectedRowData(row);
    setLeaveConfigId(row?.Id);
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

    const downloadExcelGet = async () => {
    const params: Record<string, any> = {
      ...(filtersState.id ? { id: filtersState.id } : {}),
      ...(filtersState.search ? { search: filtersState.search } : {}),
    };
    const queryString = new URLSearchParams(params).toString();
    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.LEAVE.GET_ALL_LEAVE_CONFIGURATION_EXCEL}?${queryString}`
      );
      const { success, fileDownloadId, intervalTime } = response?.data?.data || null;
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.csv";
            a.click();
            showToast.success("The file is ready!");
          },
          onFailed: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
        });
      }
    } catch (err: any) {
      showToast.error(err);
    }
  };


  return (
    <div className="p-2">
      <PageHeader
        title="Leave Configuration"
        buttons={[
          {
            label: "+ Add Leave Configuration",
            onClick: () => handleLeaveRequestView(),
            color: "#43B9B2",
          },
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
        Title="Leave Configuration"
        dynamicHeightOnRowsPerPage={true}
        data={leaveConfigurationData?.data?.data || []}
        showSpinner={leaveConfigurationLoading}
        columns={leaveConfigurationColumns(handleUpdateLeaveConfiguration)}
        tableHeaderButton={true}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={
          leaveConfigurationData?.data?.pagination?.total_records || 0
        }
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
      />
      <RouteModal
        isOpen={leaveConfigurationModal}
        toggle={toggleModal}
        title={
          editLeaveConfigurationModal === "Submit"
            ? "Add Leave Configuration"
            : "Edit Leave Configuration"
        }
        size="lg"
        content={
          <LeaveConfigurationModal
            handleSubmit={handleSubmit}
            handleClose={handleClose}
            editLeaveConfigurationModal={editLeaveConfigurationModal}
            selectedRowData={selectedRowData}
            buttonDisable={buttonDisable}
          />
        }
      />
    </div>
  );
};

export default LeaveConfiguration;

const leaveConfigurationColumns = (
  handleUpdateLeaveConfiguration: (row: any, Status: string) => void
) => [
  {
    name: "Name",
    selector: (row: { Name: string }) => row.Name,
    sortable: true,
    minWidth: "180px",
    wrap: true,
  },
  {
    name: "Leave Type",
    selector: (row: { LeaveType: string }) => row.LeaveType,
    sortable: true,
    minWidth: "180px",
    wrap: true,
  },
  {
    name: "Policy Year",
    selector: (row: { PolicyYear: number | string }) => row.PolicyYear,
    sortable: true,
    minWidth: "180px",
    wrap: true,
  },

  {
    name: "Applicable Date",
    selector: (row: { ApplyDate: string }) => row.ApplyDate,
    sortable: true,
    minWidth: "180px",
    wrap: true,
  },

  {
    name: "Leave Points",
    selector: (row: { LeavePoints: string }) => row.LeavePoints,
    sortable: true,
    minWidth: "180px",
    wrap: true,
  },
  {
    name: "Is Active",
    selector: (row: { IsActive: boolean | string }) =>
      row.IsActive === true || row.IsActive === "true" ? "True" : "False",
    sortable: true,
    minWidth: "180px",
    wrap: true,
  },
  {
    name: "Org Units",
    selector: (row: { OrgUnitNames?: string }) =>
      row.OrgUnitNames ? row.OrgUnitNames : "-",
    sortable: true,
    wrap: true,
    minWidth: "300px",
  },
  {
    name: "Attachment",
    selector: (row: { IsAttachmentReq: string }) => row.IsAttachmentReq,
    sortable: true,
    minWidth: "180px",
    wrap: true,
  },
  {
    name: "Admin approval",
    selector: (row: { AdminApproval: string }) => row.AdminApproval,
    sortable: true,
    minWidth: "180px",
    wrap: true,
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <button
        onClick={() => handleUpdateLeaveConfiguration(row, "Update")}
        className="btn btn-primary"
        style={{
          borderRadius: "20px",
          padding: "5px",
          width: "80px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "2px",
        }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];
